import React, { useState, useEffect } from "react";
import {
  Routes,
  Route,
  useNavigate,
  useLocation,
  Navigate,
} from "react-router-dom";
import baseUrl from "../api/universalApi";
import axios from "axios";
//import Ribbons from "./Ribbons";

import Home from "./componentsBlock/Home";
import Campaigns from "./componentsBlock/Campaigns";
import Payments from "./componentsBlock/Payments";
import Templates from "./componentsBlock/Templates";
import Settings from "./componentsBlock/Settings";
import NewCampaign from "./componentsBlock/NewCampaign";
import VrfDetails from "./componentsBlock/VrfDetails";
import TrackPayment from "./componentsBlock/TrackPayment";
import {
  House,
  SquareChartGantt,
  BadgeIndianRupee,
  CircleDollarSign,
  LayoutTemplate,
  BookCheck,
  CirclePlus,
} from "lucide-react";

const navItems = [
  { to: "/dashboard", label: "Home", icon: <House /> },
  { to: "/campaigns", label: "Campaigns", icon: <SquareChartGantt /> },
  { to: "/trackpayment", label: "Track Payment", icon: <BadgeIndianRupee /> },
  { to: "/vrfdetails", label: "VRF Details", icon: <BookCheck /> },
  { to: "/payments", label: "Payments", icon: <CircleDollarSign /> },
  { to: "/templates", label: "Templates", icon: <LayoutTemplate /> },

  { to: "/new-campaign", label: "New Campaign", icon: <CirclePlus /> },
];

function DashboardNav({ creatorData }) {
  const [activeCampaign, setActiveCampaign] = useState(null);

  const [campaigns, setCampaigns] = useState([]);
  const [vrfDetails, setVrfDetails] = useState(null);
  const [open, setOpen] = useState(false);
  const [formState, setFormState] = useState({});
  // console.log("Creator Data:", creatorData);
  const [activePanel, setActivePanel] = useState("Home");
  const navigate = useNavigate();
  const location = useLocation();
  const handlePanelClick = (panel) => {
    setActivePanel(panel);
  };

  // const creatorData = useSelector((state) => state.auth?.authData?.user); // Assuming you have a Redux store or context for creator data
  // console.log("Creator Data:", creatorData);

  const fetchVrfDetails = async (id) => {
    try {
      const res = await axios.get(`${baseUrl}/api/agreement/vrf/${id}`, {
        headers: {
          "Cache-Control": "no-cache",
        },
      });
      // console.log("VRF Details Response:", res.data);
      setVrfDetails(res.data?.vrfDetails);
      setFormState(res.data?.vrfDetails || {});
    } catch (err) {
      console.log(err);
      setVrfDetails(null);
      setFormState({});
    }
  };

  useEffect(() => {
    if (creatorData?._id) {
      fetchVrfDetails(creatorData?._id);
    }
  }, [creatorData]);

  const fetchCampaignsData = async (id) => {
    try {
      // Simulate fetching campaigns data
      const response = await fetch(
        `${baseUrl}/api/campaign/getCampaigns/${id}`
      );
      if (!response.ok) {
        throw new Error("Failed to fetch campaigns data");
      }
      const data = await response.json();
      // console.log("Fetched Campaigns Data:", data);

      // console.log(data)
      setCampaigns(data);
      if (data.length > 0) {
        setActiveCampaign(data[0]);
      }
    } catch (error) {
      console.error("Error fetching campaigns data:", error);
    }
  };

  useEffect(() => {
    // This effect can be used to fetch or manipulate data related to campaigns

    fetchCampaignsData(creatorData?._id);
  }, [creatorData?._id]);

  const handleCampaignRow = (row) => {
    //console.log("row",row)
    setActiveCampaign(row);
    setActivePanel("Track Payment");
  };

  return (
    <div
      className="flex min-h-screen md:flex-row  xs:flex-col"
      style={{ fontFamily: "Gilroy-Medium" }}
    >
      <aside className="w-64 h-100 shadow-md p-4 bg-gray-100 p-2 rounded-lg">
        <div className="text-xl font-bold mb-6">CreatorPay</div>
        <nav className="space-y-3 ">
          {navItems.map((item) => (
            <NavItem
              key={item.to}
              to={item.to}
              label={item.label}
              icon={item.icon}
              active={
                location.pathname === item.label.toLowerCase() ||
                activePanel === item.label
              }
              setActivePanel={setActivePanel}
            />
          ))}
        </nav>
        <div className="mt-10">
          <hr className="border-t border-gray-200 my-4" />
          <div className="mt-4 text-sm text-gray-500 text-center">
            Help and docs
          </div>
        </div>
      </aside>

      <div className="flex-1 overflow-scroll bg-white p-2">

        
        {activePanel === "Home" && (
          <Home campaigns={campaigns} handlePanelClick={handlePanelClick} />
        )}

        {activePanel === "Campaigns" && (
          <Campaigns
            creatorData={creatorData}
            campaigns={campaigns}
            setCampaigns={setCampaigns}
            handleCampaignRow={handleCampaignRow}
          />
        )}
        {activePanel === "Track Payment" && (
          <TrackPayment
            creatorData={creatorData}
            activeCampaign={activeCampaign}
            setActiveCampaign={setActiveCampaign}
            campaignData={campaigns}
          />
        )}

        {activePanel === "Payments" && <Payments />}
        {activePanel === "Templates" && <Templates />}
        {activePanel === "Settings" && <Settings />}
        {activePanel === "VRF Details" && (
          <VrfDetails
            vrfDetails={vrfDetails}
            formState={formState}
            setFormState={setFormState}
            setVrfDetails={setVrfDetails}
          />
        )}
        {activePanel === "New Campaign" && (
          <NewCampaign
            creatorData={creatorData}
            vrfDetails={vrfDetails}
            formState={formState}
            setFormState={setFormState}
            setVrfDetails={setVrfDetails}
            fetchCampaignsData={fetchCampaignsData}
          />
        )}
      </div>

    
    </div>
  );
}

function NavItem({ to, label, icon, active, setActivePanel }) {
  const handlePanelClick = (panel) => {
    setActivePanel(panel);
  };
  return (
    <button
      type="button"
      onClick={() => handlePanelClick(label)}
      className={`flex items-center gap-2 px-3 py-2 rounded-full w-full text-left ${
        active
          ? "bg-pink-100 text-pink-700 font-semibold"
          : "hover:bg-blue-100 text-gray-700"
      }`}
    >
      <span>{icon}</span>
      <span>{label}</span>
    </button>
  );
}

export default DashboardNav;
